// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"147":"133dbf50","364":"6457280d","713":"3556e8f0"}[chunkId] + ".chunk.css";
};